/**
 * Section.jsx
 * ---------------------------------------------------------------------------
 * Shared section frame: consistent vertical rhythm, max-width, and a small
 * Roman-numeral label that establishes the editorial register used
 * throughout the site.
 */

import React from "react";
import { tokens } from "../../lib/tokens.js";

export default function Section({ id, label, children, tone = "light" }) {
  return (
    <section
      id={id}
      style={{
        background: tone === "paper" ? tokens.paper : tokens.bg,
        borderTop: `1px solid ${tokens.divider}`,
        padding: "120px 32px",
      }}
    >
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        {label && (
          <div
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: 11,
              letterSpacing: "0.22em",
              textTransform: "uppercase",
              color: tokens.inkSoft,
              marginBottom: 48,
              display: "flex",
              alignItems: "center",
              gap: 16,
            }}
          >
            <span
              style={{
                width: 24,
                height: 1,
                background: tokens.ink,
                display: "inline-block",
              }}
            />
            {label}
          </div>
        )}
        {children}
      </div>
    </section>
  );
}
